import axios from './axios';
import { Issue, IssueCreate, IssueUpdate, IssuePhoto } from '../types/issue';

const BASE_URL = '/issues';

export interface GetIssuesParams {
  project_id?: number;
  line_id?: number;
  status?: string;
  rank?: string;
  issue_type?: string[];
  line_name?: string[];
  issued_by?: string[];
  cm_pic?: string[];
  approval?: string[];
  search?: string;
  order_by?: string;
  order?: 'asc' | 'desc';
  skip?: number;
  limit?: number;
}

export const issueApi = {
  getIssues: async (params?: GetIssuesParams) => {
    const response = await axios.get<Issue[]>(BASE_URL, { params });
    return response.data;
  },

  getIssue: async (id: number, projectId?: number, includeUsers: boolean = true) => {
    // Add the include_users parameter to get detailed user information
    const params: any = includeUsers ? { include_users: 'true' } : {};
    // Add project_id for composite key lookup
    if (projectId !== undefined) {
      params.project_id = projectId;
    }
    const response = await axios.get<Issue>(`${BASE_URL}/${id}`, { params });
    return response.data;
  },

  createIssue: async (data: IssueCreate) => {
    const response = await axios.post<Issue>(BASE_URL, data);
    return response.data;
  },

  updateIssue: async (id: number, data: IssueUpdate, projectId?: number) => {
    const params: any = {};
    if (projectId !== undefined) {
      params.project_id = projectId;
    }
    const response = await axios.put<Issue>(`${BASE_URL}/${id}`, data, { params });
    return response.data;
  },

  deleteIssue: async (id: number, projectId?: number) => {
    const params: any = {};
    if (projectId !== undefined) {
      params.project_id = projectId;
    }
    await axios.delete(`${BASE_URL}/${id}`, { params });
  },

  uploadPhotos: async (issueId: number, files: File[], photoType: string = 'problem', projectId?: number) => {
    const uploadedPhotos: IssuePhoto[] = [];
    
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      
      const params: any = { photo_type: photoType };
      if (projectId !== undefined) {
        params.project_id = projectId;
      }
      
      const response = await axios.post<IssuePhoto>(
        `${BASE_URL}/${issueId}/photos`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          params,
        }
      );
      uploadedPhotos.push(response.data);
    }

    return uploadedPhotos;
  },

  deletePhoto: async (issueId: number, photoId: number, projectId?: number) => {
    const params: any = {};
    if (projectId !== undefined) {
      params.project_id = projectId;
    }
    await axios.delete(`${BASE_URL}/${issueId}/photos/${photoId}`, { params });
  },

  getStatistics: async (projectId: number) => {
    const response = await axios.get<{
      total: number;
      by_status: Record<string, { count: number; percentage: number }>;
      by_rank: Record<string, { count: number; percentage: number }>;
    }>(`${BASE_URL}/statistics/${projectId}`);
    return response.data;
  },
};
